import initialState from '../store/initial-state'
import {
  PUBLIC_TOKEN,
  PUBLIC_TOKEN_SUCCESS,
  PUBLIC_TOKEN_FAILURE
} from '../constants/public-types'

export default (state = initialState.public, action) => {
  switch (action.type) {

    case PUBLIC_TOKEN:
      return {
        ...state,
        isFetching: true,
        token: null,
        error: null
      }

    case PUBLIC_TOKEN_SUCCESS:
      return { ...state, isFetching: false, token: action.payload }

    case PUBLIC_TOKEN_FAILURE:
      return { ...state, isFetching: false, token: null, error: action.payload }

    default: return { ...state }
  }
}